import React, { useEffect, useRef, useState } from 'react'
import { Grid, Paper,makeStyles } from '@material-ui/core';
import moment from 'moment';
import { useMesaEntrada } from '../../../hooks/useCases/useMesaEntrada';
import { useForm } from '../../../hooks/useForm';
import { TIPO_EFECTORES } from '../../../utils/constants';
import { BuscadorMesaEntrada } from './BuscadorMesaEntrada';
import { MESA_ENTRADA_PERMISOS } from '../../../utils/permisos';
import { IconButtonGeneric } from '../../atomic/atoms/Buttons';
import { usePermiso } from '../../../helpers/permisos';
import { StepperOspeDirecto } from './StepperOspeDirecto';
import { useFormNew } from '../../../hooks/useFormNew';
import { GenericTable } from '../../atomic/organisms/GenericTable';
import { CheckBox, DeleteForever } from '@material-ui/icons';
import { GenericModal } from '../../atomic/organisms/GenericModal';
import { ModalRechazoComprobante } from './OspeDirectoComponents/ModalRechazoComprobante';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 10,
    flexGrow: 1,
    marginTop: theme.spacing(1)
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
}));

const initModalRechazo = {
  open: false,
  idComprobante: null
}

export const GestionOspeDirecto = () => {
  const permiso = usePermiso([MESA_ENTRADA_PERMISOS.ALTA]);
  const mesa = useMesaEntrada();
  const classes = useStyles();
  const componentRef = useRef();
  // const [inputValue, setInputValue] = useState('');
  const [selected, setSelected] = useState([]);

  const { formValues: comprobante, setFormValues, reset, ...form } = useFormNew({});
  const {  areasFisicasUsuario } = useSelector(state => state.auth,);
  const tieneAreaMesa = areasFisicasUsuario.subAreaFisica !== null;
  const idArea = tieneAreaMesa ? areasFisicasUsuario?.subAreaFisica?.idSubArea : 1

  const [openModal, setOpenModal] = useState(false)
  const [modalRechazo, setModalRechazo] = useState(initModalRechazo)
  const handleCloseModal = () => {
    setOpenModal(false)
    setTimeout(reset, 100)
  }

  const stateInitial = {
    idTipoEfector: TIPO_EFECTORES.CONTRATO_PRESTADORES,
    fechaDesde: moment().format(),
    fechaHasta: moment().format(),
  };

  const [
    formValues,
    handleInputChange, ,
    setearValor
  ] = useForm(stateInitial);

  useEffect(() => {
    mesa.get.expedientesOspeDirecto({
      idTipoEfector: formValues.idTipoEfector,
      fechaDesde: moment(formValues.fechaDesde).format(),
      fechaHasta: moment(formValues.fechaHasta).format()
    })
  }, [formValues]);

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <BuscadorMesaEntrada
          formValues={formValues}
          setSelected={setSelected}
          handleInputChange={handleInputChange}
          setearValor={setearValor}
          // setInputValue={setInputValue}
        />
        <Grid item xs={12}>
          {/* <Grid container component={Paper} alignItems="center" style={{ padding: "0.25rem" }}>
            <Grid item xs={12} style={{ padding: "0.5em 1em", gap: "0.5em", display: "flex", justifyContent: "center", alignItems: "center" }}>
              <TextField
                variant="outlined"
                margin='normal'
                fullWidth
                label="Id Comprobante"
                onChange={e => setInputValue(e.target.value)}
                autoComplete="off"
                type="number"
                value={inputValue}
                InputLabelProps={{ style: { fontWeight: 'bold' } }}
              />
              <Button
                variant="contained"
                color="primary"
                size='large'
                disabled={inputValue.length < 5}
                onClick={() => {
                  dispatch(buscadorComprobanteMesaEntradaGestion({
                    idTipoEfector: formValues.idTipoEfector,
                    tipoComprobanteDocumento: formValues.tipoComprobanteDocumento,
                    buscador: inputValue
                  }, setInputValue))
                }}
              >
                Buscar por ID
              </Button>
            </Grid>
          </Grid> */}
          <Grid item xs={12} component={Paper} style={{ marginTop: "0.5em" }}>
            <GenericTable
              ref={componentRef}
              align="center"
              selected={selected}
              setSelected={setSelected}
              data={mesa.dataTransfer.comprobantes}
              withoutPagination={mesa.dataTransfer.comprobantes.length === 0}
              columns={[
                {
                  label: "Id Comprobante",
                  id: "id",
                  sort: true
                },
                {
                  label: "Prestador",
                  customBody: (item) => item?.efectorFacturacion?.razonSocial || item?.efectorFacturacion?.nombreFantasia
                },
                {
                  label: "Tipo Comprobante",
                  customBody: (item) => item.tipoComprobante?.descripcion ?? ""
                },
                {
                  label: "N° Comprobante",
                  customBody: (item) => item.nroFactura ?
                    item?.descripcionTipoFactura
                      ? `${item.descripcionTipoFactura} / ${item?.nroSucursal.toString().padStart((5), '0') || "00000"}-${item?.nroFactura.toString().padStart((8), '0')}`
                      : `${item?.nroSucursal.toString().padStart((5), '0')}-${item?.nroFactura.toString().padStart((8), '0')}`
                    : "No posee N° Comprobante"
                },
                {
                  label: "Total Comprobante",
                  customBody: (item) => `$ ${parseFloat(item?.totalComprobante).toFixed(2)}`
                },
                {
                  label: "Fecha Comprobante",
                  customBody: (item) => moment(item?.fechaInicioVigencia).format("DD/MM/YYYY")
                },
                {
                  label: "Procedencia",
                  customBody: (item) => item.procedencia?.descripcion ?? ""
                },
                ...(permiso ? [{
                  label: "Dar de Alta",
                  customBody: (item) => (
                    <IconButtonGeneric
                      Icon={CheckBox}
                      color="primary"
                      onClick={() => mesa.check.comprobanteOspeDirecto({...item, idArea}, setFormValues, () => setOpenModal(true))}
                    />
                  )
                }] : []),
                {
                  label: "",
                  customBody: (item) => (
                    <IconButtonGeneric
                      Icon={DeleteForever}
                      color="secondary"
                      onClick={() => setModalRechazo({ open: true, idComprobante: item.id })}
                    />
                  ),
                }
              ]}
            />
          </Grid>
          <GenericModal
            open={openModal}
            closeModal={handleCloseModal}
            axWidth='lg'
          >
            <StepperOspeDirecto
              comprobante={comprobante}
              onClose={handleCloseModal}
              {...{ setFormValues, ...form }}
            />
          </GenericModal>
          <GenericModal
            open={modalRechazo.open}
            closeModal={()=> setModalRechazo(initModalRechazo)}
            maxWidth='sm'
            title={`Rechazar comprobante`}
          >
            <ModalRechazoComprobante
              idComprobante={modalRechazo.idComprobante}
              cancelar={()=> setModalRechazo(initModalRechazo)}
            />
          </GenericModal>
        </Grid>
      </Grid>
    </div>
  )
}
